import { expVal } from '@atlassian/jira-feature-experiments';

const JqlValidationDecouplingTimelineExperimentRelayProvider = {
	get(): boolean {
		return expVal('jql_validation_decoupling_timeline_exp', 'isEnabled', false);
	},
};

export default JqlValidationDecouplingTimelineExperimentRelayProvider;
